module.exports = __webpack_public_path__ + "img/1bfe551.webp";